import React from "react";

function ActiveProductsIcon({fill}) {
  return (
    <>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.72 4.69975L10.47 0.18568C10.2496 0.0638899 10.0018 0 9.75 0C9.4982 0 9.2504 0.0638899 9.03 0.18568L0.78 4.70162C0.5444 4.83053 0.34772 5.02034 0.21052 5.25121C0.07331 5.48208 0.00061 5.74556 0 6.01412V14.9804C0.00061 15.2489 0.07331 15.5124 0.21052 15.7433C0.34772 15.9742 0.5444 16.164 0.78 16.2929L9.03 20.8088C9.2504 20.9306 9.4982 20.9945 9.75 20.9945C10.0018 20.9945 10.2496 20.9306 10.47 20.8088L18.72 16.2929C18.9556 16.164 19.1523 15.9742 19.2895 15.7433C19.4267 15.5124 19.4994 15.2489 19.5 14.9804V6.01506C19.4999 5.74602 19.4274 5.48195 19.2902 5.25054C19.153 5.01913 18.956 4.82889 18.72 4.69975ZM9.75 9.74819L2.21719 5.62318L9.75 1.49818L17.2828 5.62318L9.75 9.74819ZM10.5 19.0894V11.0448L18 6.94037V14.9804L10.5 19.0894Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default ActiveProductsIcon;
